import * as Styled from './form.styles';

const FormErrorMessage: React.FC<React.HtmlHTMLAttributes<HTMLSpanElement>> = ({ children }) => {
  return <Styled.FormFieldError>{children}</Styled.FormFieldError>;
};

export default FormErrorMessage;
